import { Controller } from "stimulus";

export default class extends Controller {
  showSection(e) {
    e.preventDefault()

    e.target.parentElement.children.forEach(child => {
      child.classList.toggle('active')
    })

    document.querySelectorAll('.faq-section').forEach(section => {
      section.classList.toggle('hidden')
    })
  }

  collapseBtn(e) {
    e.preventDefault()

    // 找到最近的 label 元素
    const label = e.target.closest('label');
    if (!label) return;

    // 通過 label 的 for 屬性找到對應的 input
    const inputId = label.getAttribute('for');
    const input = document.getElementById(inputId);

    if (input) {
      input.checked = !input.checked;
    }
  }
}
